/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import * as _ from 'lodash'
//img
import FloatingButtonImage from '@assets/images/banner/telegram-floating-button.png'
// css
import styled from '@themes/theme'
import { Button, TelegramSettingBtnWrap } from '@styles/button.style'
import useRootStore from '@store/useRootStore'
import { observer } from 'mobx-react'
import PaymentRewardEvent from './PaymentRewardEvent/index'
import { REWARD_COMPLETE_POPUP_TYPE } from '@views/Popup/Event/RewardComplete'
import { showToast, TOAST_TYPE } from '@utils/utils'
import { getErrorText } from '@game/errtext'
import Login from '@views/Login'
import { BannerButton } from 'containers/views/Popup/MatchupBanner/BannerButton'
import { GAME_BANNER_TYPE } from '@v2/constants/common'
import DialogUtils from '@utils/dialog-utils'

export const AdvNewsWrap = styled.div`
    width: 100%;
    height: auto;
    max-height: 100%;
    overflow: auto;
    background: ${props => props.theme.color.contentsBg};

    .img {
        width: inherit;
    }

    .link {
        position: relative;
        bottom: 65px;
        left: 10px;
        display: block;
        width: 320px;
        height: 45px;
    }

    .event-btn {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        height: auto;
        border-radius: 0;

        img {
            width: inherit;
            height: auto;
        }
    }

    .anniversary-btn {
        position: sticky;
        bottom: -1px;
        left: 0;
        width: 100%;
        height: auto;
        margin-top: -87px;
        background: none;
        border-radius: 0;

        &--img {
            width: 100%;
            height: auto;
        }
    }
`

const MatchupBannerPopup: React.FC = () => {
  const { componentStore, authStore } = useRootStore()

  if (_.isEmpty(componentStore?.selectedGameBanner)) {
    return <Fragment/>
  }

  const { id, type: bannerType, contentsImageUrl, buttonImageUrl, buttons } = componentStore.selectedGameBanner
  const isBannerButton = !_.isEmpty(buttons)


  const onClickEventBannerBtn = async () => {
    try {
      if (!authStore.isSignedIn) {
        authStore.showLoginPopup(<Login/>)
        return
      }

      let result
      let rewardPopupType
      if (bannerType === GAME_BANNER_TYPE.LIVE_BET_EVENT) {
        result = await componentStore.api.component.receiveDailyBettingEventReward({ bannerId: id })
        rewardPopupType = REWARD_COMPLETE_POPUP_TYPE.LIVE_BET_EVENT
      } else if (bannerType === GAME_BANNER_TYPE.EXTRA_PAYMENT_REWARD_EVENT) {
        result = await componentStore.api.component.receiveExtraPaymentReward({ bannerId: id })
        rewardPopupType = REWARD_COMPLETE_POPUP_TYPE.EXTRA_PAYMENT_REWARD_EVENT
      }

      if (!result) {
        return
      }

      const { rewardItem, errcode } = result
      if (_.isNil(errcode)) {
        DialogUtils.showRewardCompletePopup(rewardItem, rewardPopupType)
        return
      }

      showToast(TOAST_TYPE.INFO, getErrorText(errcode))
    } catch (err) {
      console.error(err)
    }
  }

  const isPaybackBanner = componentStore?.selectedGameBanner?.desc?.includes("(페이백)")
  const isTelegramBanner = componentStore?.selectedGameBanner?.desc?.includes("텔레(하단버튼)")

  const onShowTelegramSetting = () => {
    if (!authStore.isSignedIn) {
      authStore.showLoginPopup(<Login/>)
      return
    }
    DialogUtils.showTelegramSetting()
  }

  return (
    <AdvNewsWrap>
      {contentsImageUrl && (
        <img src={contentsImageUrl} alt="승부사 소식" className="img"/>
      )}

      {/* 참여형 이벤트 하단버튼 */}
      {buttonImageUrl && (
        <Button TP className="event-btn" onClick={onClickEventBannerBtn}>
          <img src={buttonImageUrl} alt="참여형 이벤트 버튼"/>
        </Button>
      )}

      {/* 2주년 이벤트 플로팅 버튼 */}
      {isPaybackBanner && <PaymentRewardEvent/>}

      {/* 링크연결 - 다운로드 링크버튼 */}
      {isBannerButton && (
        <BannerButton bannerButtonData={buttons}/>
      )}

      {isTelegramBanner && (
        <TelegramSettingBtnWrap className="telegram-setting-btn-wrap">
          <div className="telegram-setting-tooltip">
            <span className="telegram-setting-tooltip--text">텔레그램 연동 혜택 받자!</span>
          </div>
          <button type="button" onClick={onShowTelegramSetting} className="telegram-setting-btn">
            <img src={FloatingButtonImage} alt="알림 설정하기"/>
          </button>
        </TelegramSettingBtnWrap>
      )}
    </AdvNewsWrap>
  )
}
export default observer(MatchupBannerPopup)
